import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Common from "./common/CommonApp";
import { AppProvider } from "context/AppContext";

const App = () => {
    const location = useLocation();
    const [subdomain, setSubdomain] = useState<string>("");

    useEffect(() => {
        const { host, port } = window.location;
        const parts = host.split(".");

        const sub = parts.length > 1 && parts[0] !== "localhost" ? parts[0] : "default";
        setSubdomain(sub);

        // const isDevMode = parts.includes(`localhost:${port}`); // 개발모드
        // const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드

        // const isDevelop = isDomainDevelop || isDevMode;
        // const devPath = isDevelop ? "Dev " : "";

        // let title = devPath + "일신그룹 - 국내외 물류 전문 일신그룹";
        // if (sub === "air") title = devPath + "일신항공해운 - 국내외 물류 전문 일신그룹";
        // else if (sub === "morning") title = devPath + "일신모닝택배 - 국내외 물류 전문 일신그룹";
        // else if (sub === "quick") title = devPath + "일신모닝퀵 - 국내외 물류 전문 일신그룹";
        // else if (sub === "express") title = devPath + "일신특송화물 - 국내외 물류 전문 일신그룹";
        // else if (sub === "ilshinconsole" || sub === "console") title = devPath + "일신그룹관리자";

        // document.title = title;
    }, [subdomain]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const changeSubdomain = (subdomain: string) => {
        // setSubdomain(subdomain);
        const { protocol, host, port } = window.location;
        const parts = host.split(".");

        const isDevMode = parts.includes(`localhost:${port}`); // 개발모드
        const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드

        const isDevelop = isDomainDevelop || isDevMode;

        let domain = isDevelop ? (isDevMode ? `localhost:${port}` : "likeweb.co.kr") : "ilshingroup.com";

        const newUrl = `${protocol}//${subdomain}.${domain}`;
        window.location.href = newUrl;
    };

    return (
        <AppProvider>
            <Routes>
                <Route path="/*" element={<Common subdomain={subdomain} changeSubdomain={changeSubdomain} />} />
            </Routes>
        </AppProvider>
    );
};

export default App;
